var app = angular.module("leonardo");

var AccountUserDeleteDialog = function ($scope, ngDialog, $rootScope, $timeout, FormErrorsService, AuthDataService, AccountUserRoleService) {

  $scope.accountUser = $scope.ngDialogData.accountUser;
  $scope.currentRole = $scope.accountUser.role;

  $scope.isRoleExternal = function () {
    return !isNull($scope.currentRole) && !isNull($scope.currentRole.base_type) &&
      ($scope.currentRole.base_type.toString() === AccountUserRoleService.BASE_TYPE_EXTERNAL_APPROVER);
  };

  $scope.isRoleOwner = function (role) {
    return role ? !isNull(role.base_type) && (role.base_type.toString() === AccountUserRoleService.BASE_TYPE_OWNER) : false;
  };
  
  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if ($scope.accountUser.is_reported) {
      $timeout(function() {
        ngDialog.open({
          template: 'views/templates/dialog/account-user/report-to.html',
          controller: 'AccountUserReportToDialog',
          data: { accountUser: $scope.accountUser }
        });
      }, 200);
      $scope.closeThisDialog();
    }
    else {
      let params = {}
      if ($scope.isRoleExternal()  && $scope.isRoleOwner(AuthDataService.getAccountUser().role)) {
        params = {
          with_externals: true,
        };
      }
      $scope.accountUser.remove(params).then(function () {
        $rootScope.$broadcast('account-user:deleted');
        $scope.closeThisDialog();
      });
    }
  };
};

app.controller('AccountUserDeleteDialog', ['$scope', 'ngDialog', '$rootScope', '$timeout', 'FormErrorsService', 'AuthDataService', 'AccountUserRoleService', AccountUserDeleteDialog]);
